import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../reducers/store';
import { useNavigate, useParams } from 'react-router-dom';

import './editEnrollment.css'
import { StateEnrollmentParams } from '../../../types/enrollment/enrollment';
import { actionFetchEnrollmentUser } from '../../../actions/enrollment';
import { EditEnrollmentDetails, Loader, PageHeader, ViewEnrollmentProfile } from '../../../components';

interface PostDataParams {
  selectedFile?: string;
  firstName?: string;
  lastName?: string;
  sex?: string;
  emailAddress?: string;
  phoneNumber?: string;
  resume?: string;
}

const EditEnrollment = () => {
  const dispatch                            = useDispatch<AppDispatch>();
  const navigate                            = useNavigate();
  const { id }                              = useParams();
  const { isLoading, singleEnrollmentUser } = useSelector((state: RootState) => state?.enrollmentList);
  const [onePost, setOnePost]               = useState<StateEnrollmentParams>(); //or use the null below
  const lineRef                             = useRef<HTMLDivElement | null>(null);
  const [activeTab, setActiveTab]           = useState<number>(0);
  const tabButtons                          = ['Enrollment Profile', 'Edit Enrollment details'];

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };

  useEffect(() => {
    if (lineRef.current) {
      const parent = lineRef.current.parentNode as HTMLElement;
      const activeButton = parent.querySelector('.active') as HTMLElement;

      if (activeButton) {
        lineRef.current.style.width = `${activeButton.offsetWidth}px`;
        lineRef.current.style.left = `${activeButton.offsetLeft}px`;
      }
    }
  }, [activeTab]);

  useEffect(() => {
    if (id) {
      dispatch(actionFetchEnrollmentUser({ id }));
    }
  }, [id, dispatch]);

  return (
    <>
      <title>Edit Enrollment</title>
      <PageHeader title="Edit Enrollment Data" description="Welcome to the Enrollment Detail" download="Download Report" />

      <div className='user-profile-wrapper'>
        {isLoading ? (
            <Loader />
          ) : singleEnrollmentUser ? (
            <>
              <div className='user-profile-body'>
                <div className='user-profile-tab-box'>
                  {tabButtons.map((tab, index) => (
                    <button key={index} className={`user-profile-tab-btn ${activeTab === index ? 'active' : ''}`} onClick={() => handleTabClick(index)} >
                      {tab}
                    </button>
                  ))}
                  <div className='user-profile-btn-line' ref={lineRef}></div>
                </div>

                <div className='user-profile-content-box'>
                  <div className={`user-profile-content ${activeTab === 0 ? 'active' : ''}`}>
                    <ViewEnrollmentProfile enrollmentData={singleEnrollmentUser} />
                  </div>
                  <div className={`user-profile-content ${activeTab === 1 ? 'active' : ''}`}>
                    <EditEnrollmentDetails enrollmentData={singleEnrollmentUser} />
                  </div>
                </div>
              </div>
            </>
            )
           : (
            <><p>Empty data</p></>
            // <EmptyCard title="profile" linkName="Profile" link="/users/create-profile" />
        )}
      </div>
    </>
  )
}

export default EditEnrollment